// Bernie
import { alterClientStores } from 'bernie-alter';
import { ClientFactories, ContextStore, Store } from 'bernie-core';
import { ClientLogger } from 'bernie-client';
import { ContextInput } from 'bernie-context';
import { NOOP_LOGGER } from 'bernie-logger';

// Sources
import { BexApiSource } from 'sources/bex-api-source';
import { BentoSource } from 'src/common/sources/bento-source';
import { HotelInfoSource } from 'sources/hotel-info-source';
import { HotelOffersSource } from 'sources/hotel-offers-source';
import { HotelSearchApiSource } from 'sources/hotel-search-api-source';
import { PoiContentSource } from 'sources/poi-content-source';
import { RateCalendarApiSource } from 'sources/rate-calendar-api-source';
import { ShortlistApiSource } from 'sources/shortlist-api-source';
import { TripDetailsSource } from 'sources/trip-details-source';

// Stores
import { AdvertisingStore } from './advertising-store';
import { BentoStore } from 'src/common/bento/bento-store';
import { CheckoutStore } from './checkout-store';
import { CurrentHotelStore } from './current-hotel-store';
import { CustomerInterestsStore } from 'stores/customer-interests-store';
import { FindAnswersStore } from './find-answers-store';
import { MultiItemStore } from './multi-item-store';
import { QualtricsStore } from './qualtrics-store';
import { SearchCriteriaStore } from './search-criteria-store';
import { SearchResultsStore } from './search-results-store';
import { ShortlistStore } from './shortlist-store';
import { UIPageStore } from './ui-page-store';

const buildBexApiSource = (contextInput: ContextInput): BexApiSource =>
  new BexApiSource('', ClientLogger.getLoggerWithIdentifier('pwa.source.bexapi'), { 'Device-User-Agent-ID': contextInput.identity.duaid });

export const stores: ClientFactories = {
  ...alterClientStores,

  advertising: (): Store => new AdvertisingStore({}, ClientLogger.getLoggerWithIdentifier('pwa.store.advertising')),

  context: (): Store => new ContextStore(null, NOOP_LOGGER),

  bento: (): Store => new BentoStore(null, NOOP_LOGGER, new BentoSource('', ClientLogger.getLoggerWithIdentifier('pwa.source.bento'))),

  currentHotel: ({ bexApiContext, l10n }): Store =>
    new CurrentHotelStore(
      new HotelInfoSource('', ClientLogger.getLoggerWithIdentifier('pwa.source.hotelinfo')),
      new HotelOffersSource('', ClientLogger.getLoggerWithIdentifier('pwa.source.hoteloffers')),
      buildBexApiSource(bexApiContext),
      new HotelSearchApiSource('', ClientLogger.getLoggerWithIdentifier('pwa.source.hotelsearch')),
      new RateCalendarApiSource('', ClientLogger.getLoggerWithIdentifier('pwa.source.ratecalendarapi')),
      new PoiContentSource('', ClientLogger.getLoggerWithIdentifier('pwa.source.poicontent')),
      {},
      l10n,
      ClientLogger.getLoggerWithIdentifier('pwa.store.currenthotel')
    ),
  searchCriteria: ({ l10n }): Store => new SearchCriteriaStore({}, l10n, ClientLogger.getLoggerWithIdentifier('pwa.store.searchcriteria')),

  searchResults: ({ bexApiContext }): Store =>
    new SearchResultsStore(
      new HotelSearchApiSource('', ClientLogger.getLoggerWithIdentifier('pwa.souce.hotelsearch')),
      buildBexApiSource(bexApiContext),
      {},
      ClientLogger.getLoggerWithIdentifier('pwa.store.searchresults')
    ),

  multiItem: ({ bexApiContext, l10n }): Store =>
    new MultiItemStore(buildBexApiSource(bexApiContext), {}, ClientLogger.getLoggerWithIdentifier('pwa.store.multiitem'), l10n),
  qualtrics: (): Store => new QualtricsStore({}),
  shortlist: (): Store =>
    new ShortlistStore(
      new ShortlistApiSource('', ClientLogger.getLoggerWithIdentifier('pwa.source.shortlist')),
      {},
      ClientLogger.getLoggerWithIdentifier('pwa.store.shortlist')
    ),
  uiPage: (): Store => new UIPageStore({}),
  checkout: (): Store => new CheckoutStore(new TripDetailsSource('', ClientLogger.getLoggerWithIdentifier('pwa.source.tripdetails')), {}),
  findAnswersStore: ({ bexApiContext }): Store =>
    new FindAnswersStore(buildBexApiSource(bexApiContext), {}, ClientLogger.getLoggerWithIdentifier('pwa.store.findAnswers')),
  customerInterestsStore: ({ bexApiContext }): Store =>
    new CustomerInterestsStore(
      buildBexApiSource(bexApiContext),
      {},
      ClientLogger.getLoggerWithIdentifier('pwa.store.customerInterests'),
      null
    )
};
